import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTypedParams } from 'react-router-typesafe-routes/dom';
import { AppRoutes, useNavBack } from '~/app/app.routes';
import { AuthService } from '~/service/service.auth';
import { OlfactiveService } from '~/service/service.olfactive';
import { UIService } from '~/service/service.ui';
import { OlfactiveCreateDto } from '~/shared/dto/admin/olfactive.dto';
import { Form } from '~/shared/form/form';
import { useService } from '~/shared/service/service.base';
import { FieldImage } from '~/view/fields/field.images';
import { FieldNumber } from '~/view/fields/field.number';
import { FieldText } from '~/view/fields/field.text';
import { FieldTextTranslations } from '~/view/fields/field.translations';
import { EditCenter, EditContainer, EditLeft, EditRight } from '~/view/view.edit';

export const OlfactiveEditPage = observer(() => {
	const [ui, auth, olfactives] = useService(UIService, AuthService, OlfactiveService);
	const navBack = useNavBack();
	const { id } = useTypedParams(AppRoutes.OlfactiveEdit);

	const form = Form.use(OlfactiveCreateDto, {
		name: 'OlfactiveCreateDto',
		onSubmit: dto =>
			olfactives.save(id, dto).then(() => {
				navBack();
				ui.notify('Olfactive saved successfully', 'success');
			}),
		initial: () => olfactives.getOne(id),
	});

	ui.usePageTitle(form.initial?.name ? `Olfactive - ${form.initial?.name}` : '');
	const canSave = id ? auth.can('notes', 'UPDATE') : auth.can('notes', 'CREATE');

	return (
		<EditContainer async={olfactives.async}>
			<EditLeft>
				<FieldImage field={form.$image} />
			</EditLeft>
			<EditCenter>
				<FieldNumber disabled={!!id} field={form.$id} />
				<FieldText field={form.$name} />
				<FieldTextTranslations languages={olfactives.tr.languages} field={form.$translations} />
				<FieldText multiline field={form.$comment} />
			</EditCenter>
			<EditRight>
				<Button variant="contained" onClick={form.submit} disabled={!canSave}>
					Save
				</Button>
				<br />
				<Button variant="outlined" onClick={navBack}>
					Cancel
				</Button>
				<Button variant="outlined" onClick={form.reset}>
					Reset
				</Button>
				{id && (
					<>
						<br />
						<Button
							disabled={!auth.can('notes', 'DELETE')}
							variant="outlined"
							color="error"
							onClick={() =>
								ui.confirmDelete(() =>
									olfactives.delete(id).then(() => {
										navBack();
										ui.notify('Olfactive deleted successfully', 'success');
									}),
								)
							}
						>
							Delete
						</Button>
					</>
				)}
			</EditRight>
		</EditContainer>
	);
});
